import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="assets/logo.png" alt="WE CARE ASSURANCE" />
            </div>
            <p>
              Protecting what matters most to you with trust, care, and
              unwavering commitment since 2003.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>

              <a href="#" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <circle cx="18" cy="6" r="1" fill="currentColor" />
                </svg>
              </a>

              <a href="#" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M16 8A6 6 0 0 1 22 14V21H18V14A2 2 0 0 0 16 12A2 2 0 0 0 14 14V21H10V14A6 6 0 0 1 16 8Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <rect
                    x="2"
                    y="9"
                    width="4"
                    height="12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="4"
                    cy="4"
                    r="2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="footer-section f1-s2">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/plans">Insurance Plans</Link></li>
              <li><Link to="/claims">Claims</Link></li>
            </ul>
          </div>

          <div className="footer-section f1-s3">
            <h3>Insurance Plans</h3>
            <ul>
              <li><Link to="/plans#pl">Personal Line</Link></li>
              <li><Link to="/plans#cl">Corporate Line</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <div className="contact-info">
              <p>
                <strong>Anand Branch:</strong><br />
                F-4/5 City Plaza, Nr. Baliyadev Crossing, Nr. Sardargunj,
                Anand-388001<br />
                <strong>Phone:</strong> 98241 29366, 93772 77703
              </p>
              <p>
                <strong>Vadodara Branch:</strong><br />
                504, The Park, Akshar Chowk, Old Padra Road, Vadodara-390020
              </p>
              <p><strong>Email:</strong> info@wecareassurance.com</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2025 WE CARE ASSURANCE. All rights reserved. | Designed by
            Aina Tech Services LLP.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
